import { useContext, useMemo } from 'react';

import { RightOutlined } from '@ant-design/icons';
import styled from 'styled-components';

import { LayoutContext } from '@/layouts/baseLayout/provider';
import { buriedPoint } from '@/utils/buriedPoint';
import Utils from '@/utils/Utils';

// 映射关系
export const slogan2Provider = {
  Digikey: 'digikey',
  Mouser: 'mouser',
  Arrow: 'arrow',
  Verical: 'verical',
  AventUs: 'avnet_us',
  AventEur: 'avnet_eur',
  AvnetAsia: 'avnet_asia',
  Future: 'future',
  Element: 'element',
  'RS Components': 'rscomponents',
  Onlinecomponents: 'onlinecomponents',
  Corestaff: 'corestaff',
  TTI: 'tti',
  TME: 'tme',
  Rutronik: 'rutronik',
  Questcomp: 'questcomp',
  Powell: 'powell',
  Sager: 'sager',
  Chip1stop: 'chip1stop',
  Element14Uk: 'element14_uk',
  Heilind: 'heilind',
  ti_ovs: 'ti_ovs',
  Burklin: 'burklin',
};

const TitleWrapper = styled.div`
  background: linear-gradient(180deg, #b9e6ff 0%, #e5f6ff 100%);
`;

// 特殊的立创订货
export const spBookObj = {
  te: 'TE',
  rochester: 'Rochester',
};

export default function OverseasList(props) {
  const {
    provider,
    providerAlias,
    slogan,
    children,
    linkUrl,
    pageNumber,
    pageTotal,
    isLcscBookShow,
    total,
    clickMore,
    spm,
  } = props;
  const { resourceData } = useContext(LayoutContext);

  const leftCountDom = useMemo(() => {
    let text = '';
    if (pageNumber > pageTotal) {
      text = '';
    } else {
      const leftCount = total - (pageNumber * 10 - (isLcscBookShow ? 7 : 8));
      text = (
        <div className="mt-[10px] flex cursor-pointer items-center justify-center text-[#444]">
          还有<span className="text-[#0294E7]">{leftCount}</span>
          个商品未显示，点击
          <span className="mr-[4px] text-[#0294E7]" onClick={clickMore}>
            加载更多
          </span>
          <span className="mb-[3px] inline-block size-[7px] rotate-[225deg] border-l-[1px] border-t-[1px] border-solid border-[#0294e8]"></span>
        </div>
      );
      if (leftCount <= 0) {
        text = '';
      }
    }
    return text;
  }, [total, pageNumber, isLcscBookShow]);

  const isLcBook = useMemo(() => {
    return isLcscBookShow;
  }, [provider]);

  const sloganText =
    isLcBook && !spBookObj[provider] ? '原厂正品 | 免国际邮费 | 非自营现货 交期、价格需再次核实' : slogan;

  function gotoOvease() {
    buriedPoint({
      op: 'go_oversea_page',
    });
  }

  const providerName = useMemo(() => {
    if (spBookObj[provider]) {
      return spBookObj[provider];
    } else if (isLcBook) {
      return '立创订货';
    }
    return providerAlias;
  }, [provider]);

  return (
    <div id={provider} className="mb-[20px]" data-spm={spm}>
      <div className="overflow-hidden rounded-[10px] hover:shadow-[0_1px_8px_2px_rgba(0,0,0,0.08)]">
        <div className={`flex items-center bg-[#E5F6FF]`}>
          <TitleWrapper className="flex h-[47px] items-center pl-[23px] pr-[15px] text-[20px] font-bold text-[#333]">
            {providerName}
          </TitleWrapper>
          <div
            className={`mr-[8px] h-[47px] w-[26px] bg-[url(https://static.szlcsc.com/ecp/assets/newWeb/so/hwdg-title.png)]`}
            style={{
              backgroundSize: '26px 47px',
            }}
          ></div>
          <div className={`flex-1 text-[16px] text-[#333]`}>
            {linkUrl ? (
              <a href={linkUrl} target="_blank" aria-label="活动链接">
                {sloganText}
              </a>
            ) : (
              sloganText
            )}
          </div>
          {!Utils.isLcBook(provider) && (
            <a
              className="pr-[19px] text-[14px] text-[#3D3D3D]"
              href={`${resourceData?.projectConfigVO?.lcscSearchUrl}/overseas.html`}
              target="_blank"
              onClick={gotoOvease}
            >
              <span>海外代购</span>
              <RightOutlined />
            </a>
          )}
        </div>
        {children}
      </div>
      {leftCountDom}
    </div>
  );
}
